var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"slide","enter-active-class":"animate__animated animate__zoomIn my-delay-0_5s my-element-1_5s"}},[(_vm.isRresh)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }